import {ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output} from '@angular/core';
import {Config} from '../../../models/config';
import {AbstractControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {Culture, Timezone} from '../../..';
import {Country} from '../../../models/country';
import {Product} from '../../../models/product';
import {Device} from '../../../models/device';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as moment from 'moment';

@Component({
  selector: 'storever-form-typeahead',
  templateUrl: './form-typeahead.component.html',
  styleUrls: ['./form-typeahead.component.scss']
})
export class FormTypeaheadComponent implements  OnDestroy {
  config: Config;
  group: FormGroup;
  endLessDate = false ;
  // tslint:disable-next-line:no-any
  datas: Observable<Timezone[] | Culture[] | Country[] | Product[] | Device[] | any[]>;

  // Declare the property
  @Output() typeaheadQueryChange: EventEmitter<string> = new EventEmitter<string>();

  get isEnabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale , private cdr: ChangeDetectorRef) {
  }

  noResult(result: boolean): void {
    // if (result && this.group.get(this.config.controlName[0]).value
    //  && this.group.get(this.config.controlName[0]).value.length
    //  && !this.config.options.typeaheadAction) {
    //   this.group.get(this.config.controlName[0]).patchValue(this.group.get(this.config.controlName[0]).value.slice(0, -1))
    // }
  }
  /* tslint:disable */
  public typeaheadOnSelect(e: any): void {
    this.group.get(this.config.controlName[1]).patchValue(e.item[this.config.options.value]);
    if (this.config && this.config.options && this.config.options.optionsValue){
      this.group.get(this.config.options.optionsValue).patchValue(e.item[this.config.options.optionsValue]);
    }
  }

  /* tslint:disable */
  public typeaheadQueryHasChanged(e: any): void {
    this.typeaheadQueryChange.emit(e);
  }

  get getFormByControlName(): AbstractControl {
    return this.group.get(this.config.controlName[0])
  }

  get getControlName(): string {
    return this.config.controlName[0]
  }

  get getControlNameDetail(): AbstractControl {
    return this.group.controls[this.config.controlName[0]];
  }
  ngOnDestroy(): void {
    this.endLessDate = false
  }

  // tslint:disable-next-line:no-any
  checkboxChange(event: any): void {
    if (event.target.checked) {
      this.endLessDate = true;
      if ( this.config.options.checkboxEndlessModeCheck === true) {
        this.group.get(this.config.controlName[0]).clearValidators();
        this.group.get(this.config.controlName[0]).updateValueAndValidity();
        this.group.get(this.config.controlName[1]).clearValidators();
        this.group.get(this.config.controlName[1]).updateValueAndValidity();
      }
      this.group.get(this.config.controlName[0]).patchValue(null);
      this.group.get(this.config.controlName[1]).patchValue(null);
      // this.group.get(this.config.controlName[0]).disable();
    } else {
      this.endLessDate = false;
      this.group.get(this.config.controlName[0]).enable();
      if ( this.config.options.checkboxEndlessModeCheck === true) {
        this.group.get(this.config.controlName[0]).setValidators([Validators.required]);
        this.group.get(this.config.controlName[0]).updateValueAndValidity();
        this.group.get(this.config.controlName[1]).setValidators([Validators.required]);
        this.group.get(this.config.controlName[1]).updateValueAndValidity();
      }
      // if (moment(this.group.get(this.config.controlName[0]).value).format('YYYY-MM-DD') === '2099-12-31' ||
      //   !this.group.get(this.config.controlName[0]).value) {
      //   // this.group.get(this.config.controlName[0]).patchValue(moment().format('YYYY-MM-DD'));
      //   this.cdr.detectChanges();
      // }
    }

  }
}
